import { AUTHENTICATED, ERROR_AUTHENTICATION, ERROR_CLEAR_AUTHENTICATION, GROUPS, NOT_AUTHENTICATED, USERS } from '../constants/actionTypes.js'

const storedUser = localStorage.getItem("user");
const user = storedUser ? JSON.parse(storedUser) : null;

const initialState = {
    authChecked: false,
    loggedIn: false,
    currentUser: user,
    groups : [],
    users : []
}

export default (authentication = initialState, action) => {
    switch(action.type){
        case AUTHENTICATED:
            return {
                ...authentication,
                authChecked: true,
                loggedIn: true,
                currentUser: action.payload,
                error : undefined
              };
        case ERROR_AUTHENTICATION: 
            return {
                ...authentication,
                error : action.payload.error
              };
        case ERROR_CLEAR_AUTHENTICATION: 
            return {
                ...authentication,
                error : undefined
              };
        case NOT_AUTHENTICATED:
            return {
                ...authentication,
                authChecked: true,
                loggedIn: false,
                currentUser: null,
                error : undefined
              };
        case GROUPS:
            let groups = action.payload.map(g => ({_id : g , name : g}))
            return {
                ...authentication,
                groups,
                error : undefined
              };
        case USERS:
            let users = action.payload
            return {
                ...authentication,
                users,
                error : undefined
              };
        default :
            return authentication
    }
}